module.exports = __webpack_public_path__ + "static/media/dropdown_arrow_black.b2293abf.svg";